import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class TokenBlot extends Inline {
  static blotName = 'token';
  static tagName = 'span';
  static className = 'token-value';

  static create(value) {
    const node = super.create();
    let tokenValue = typeof value === 'object' ? value.token : value;
    let dataType = typeof value === 'object' ? value.dataType : null;

    node.setAttribute('data-token', tokenValue);
    if (dataType) {
      node.setAttribute('data-type', dataType);
      node.classList.add(`${this.className}--${dataType}`);
    }
    node.innerText = `{{${tokenValue}}}`;
    node.setAttribute('contenteditable', false);
    node.setAttribute('data-atomic', true);

    return node;
  }

  static value(node) {
    return {
      token: node.getAttribute('data-token'),
      dataType: node.getAttribute('data-type'),
    };
  }

  deleteAt() {
    return;
  }
}

export const addTokenEnterHandler = (quill) => {
  quill.keyboard.addBinding({ key: 13, collapsed: true }, (range) => {
    const [blot] = quill.getLeaf(range.index - 1);
    if (blot?.domNode?.getAttribute('data-atomic')) {
      quill.insertText(range.index, '\n', { user: 'user' });
      quill.setSelection(range.index + 1);
      return false;
    }
    return true;
  });
};

export default TokenBlot;
